// Ricerca testuale dei campi "cerca" del portale, quelli che filtrano una
// lista gia' caricata (segnalazione del cliente
// OwlCaveLabs/syndesia-l2c-support#4).
//
// Prima si cercava la stringa digitata tale e quale dentro i campi della
// riga: "apert" trovava «Apertura Commessa», "apert comm" non trovava
// niente, perche' quella sequenza esatta non compare da nessuna parte.
// Adesso la stringa si spezza sugli spazi e la riga passa se contiene tutte
// le parole.
//
// Ogni parola si cerca nell'insieme dei campi della riga, non ognuna nello
// stesso campo: "apert 42" trova la regola 42 che si chiama Apertura. La
// frase intera resta un caso particolare del match a parole, quindi niente
// di quel che si trovava prima smette di trovarsi: si aggiungono risultati,
// non se ne tolgono.
//
// Le pagine legacy (Handlebars) non importano questo file: hanno la copia
// UTILS.matchesAllWords in backend/flk_modules/flk-globals/flk-globals.js,
// da tenere allineata.

export type SearchableField = string | number | null | undefined;

// Le parole da cercare. Stringa vuota o soli spazi: nessuna parola, cioe'
// nessun filtro.
export function searchWords(query: string | null | undefined): string[] {
  if (typeof query !== 'string') return [];
  return query.toLowerCase().trim().split(/\s+/).filter(Boolean);
}

export function matchesAllWords(
  query: string | null | undefined,
  fields: SearchableField[],
): boolean {
  const words = searchWords(query);
  if (words.length === 0) return true;

  // I campi diventano un testo solo, separati da uno spazio perche' due campi
  // accostati non formino una parola che nessuno dei due contiene.
  const haystack = fields
    .filter((f) => f !== null && f !== undefined && f !== '')
    .map((f) => String(f).toLowerCase())
    .join(' ');

  return words.every((w) => haystack.includes(w));
}

// Lo stesso criterio per i menu a tendina con ricerca (v-autocomplete e
// v-combobox di Vuetify), che di serie cercano la stringa intera: "asse
// connession" non trovava il modello «...assegnatario... connessione».
// Firma del prop `filter` di Vuetify 2; e' installato come default per tutti
// i menu in plugins/vuetify.ts.
export function matchesItemWords(
  _item: unknown,
  queryText: string,
  itemText: string,
): boolean {
  return matchesAllWords(queryText, [itemText]);
}
